// removed by extract-text-webpack-plugin
module.exports = {"container":"_3DSKT7S_TQqw79gnwLubPU"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/sponsors/sponsors.css
// module id = 107
// module chunks = 0